goog.provide('el8.util.amplitude.letterHelpers');

goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.consts');


/**
 * Log that a create letter event occurred.
 *
 * @param {string} source : where in the app the create letter was triggered
 * @param {string} letterType : is it a referral, provider letter, or patient letter
 */
el8.util.amplitude.logStartLetter = function (source, letterType) {
    var ampData = {
        source: source,
        'letter type': letterType
    };
    var eventType = letterType===el8.util.consts.REFERRAL_LETTER ? "start referral" : "start letter";
    el8.util.amplitude.logEvent(eventType, ampData);
};

/**
 * Log that a letter was completed. It will require information like what was
 * the text of the button/link that was clicked.
 *
 * @param {string} action : what the text was on the clicked button (e.g. Sign & Send)
 * @param {letter} letter : front end model instance for Letter/ReferralOrder. See el8.ptdata.model.letter
 */
el8.util.amplitude.logCompleteLetter = function (action, letter) {
    // don't want to log if letter is not the letter instance
    if (!letter) { return; }

    var ampData = {
        action: action,
        'transmission method': letter.getDeliveryMethod(),
        'number of attachments': letter.getAttachments().length,
        'fax copies': letter.isFaxAttachments(),
        'recipient account type': letter.getDeliveryMethod(),
        'recipient type': letter.getRecipientType(),
        'grant access in letter': letter.isWithPlrInvite()
    };
    var eventType = letter.getLetterType()===el8.util.consts.REFERRAL_LETTER ? "complete referral" : "complete letter";
    el8.util.amplitude.logEvent(eventType, ampData);

    if (el8Globals.FEATURES.PLR4Everyone && letter.isWithPlrInvite()) {
        el8.util.amplitude.logEvent('grant access to share via collaborative record from letter');
    }
};

/**
 * Log that we added a recipient for a letter.
 *
 * @param {letter} letter : front end model instance for Letter/ReferralOrder. See el8.ptdata.model.letter
 */
el8.util.amplitude.logAddLetterRecipient = function (letter) {
    // don't want to log if letter is not the letter instance
    if (!letter) { return; }

    var ampData = {
        'recipient account type': letter.getDeliveryMethod(),
        'recipient type': letter.getRecipientType()
    };

    el8.util.amplitude.logEvent('add recipient', ampData);
};
